"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
/**
 * アイテム/コレクションのステータスを示すタグ
 *
 * @param label 項目の表示文言
 * @param color タグの色
 */
var Tag = function (_a) {
    var label = _a.label, color = _a.color;
    return ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", children: label }), variant: "filled", 
        /**
         * @description [ClickUp] https://app.clickup.com/t/79thfj
         * material-uiのcolor拡張PRがマージされ次第修正
         * https://github.com/mui-org/material-ui/issues/13875#issuecomment-761156846
         @ts-ignore */
        color: color }));
};
exports.Tag = Tag;
